import { motion } from 'framer-motion'
import { HOOFDSCHERM, MODULES, t } from '../content/content'
import { useKiosk } from '../state/store'
import { ModuleIcoon, Pijl } from './Iconen'

/** Vier gelijkwaardige knoppen (Klantcases verviel op 6 oktober), met de campagnekop erboven. */
export function Hoofdscherm() {
  const taal = useKiosk((s) => s.taal)
  const ga = useKiosk((s) => s.ga)
  const vergrendeld = useKiosk((s) => s.vergrendeld)

  return (
    <>
      <div className="kiosk-podium">
        <motion.div
          className="kiosk-kicker"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        >
          {t(HOOFDSCHERM.kicker, taal)}
        </motion.div>
        <motion.h1
          className="kiosk-hero"
          initial={{ opacity: 0, y: 26 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        >
          {t(HOOFDSCHERM.hero, taal).split('\n').map((regel, i) => (
            <span key={i} style={{ display: 'block' }}>
              {i === 1 ? <em>{regel}</em> : regel}
            </span>
          ))}
        </motion.h1>
        <motion.p
          className="kiosk-onderkop"
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.16, ease: [0.16, 1, 0.3, 1] }}
        >
          {t(HOOFDSCHERM.onderkop, taal)}
        </motion.p>
      </div>

      <div className="kiosk-actiebalk">
        {MODULES.map((m, i) => (
          <motion.button
            key={m.id}
            className="kiosk-tegel"
            disabled={vergrendeld}
            onClick={() => ga(m.id)}
            initial={{ opacity: 0, y: 34 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.28 + i * 0.07, ease: [0.16, 1, 0.3, 1] }}
          >
            <ModuleIcoon id={m.id} />
            <Pijl />
            <span className="kiosk-tegel-nr">{m.nr}</span>
            <span className="kiosk-tegel-naam">{t(m.naam, taal)}</span>
            <span className="kiosk-tegel-sub">{t(m.sub, taal)}</span>
          </motion.button>
        ))}
      </div>
    </>
  )
}
